import { DateTime } from "luxon";

import { DateOnly } from "./DateOnly";

class LuxonDateTimeParser {
    public static parse(date: DateTime | DateOnly | Date | string): DateTime | null {
        if (!date)
            return null;

        // parse raw date
        let parsed: DateTime;
        if (date instanceof DateTime)
            parsed = date;
        else if (date instanceof DateOnly)
            parsed = date.toLuxon();
        else if (date instanceof Date)
            parsed = DateTime.fromJSDate(date as Date);
        else
            parsed = DateTime.fromISO(date, { setZone: true });

        return parsed;
    }

    public static getAgeAsYearMonth(birthday: Date): { years: number, months: number } {
        const duration = DateTime.utc().diff(this.parse(birthday), ["years", "months", "days"]); // luxon floors all specified units, except the highest-precision one.
        return duration.toObject() as { years: number, months: number };
    }
}

export { LuxonDateTimeParser };
